import React from 'react';
// import TempNav from '@layouts/TempNav';
import Navbar from '@layouts/Navbar';

export default function TestPag2() {
  return (
    <>
      <Navbar/>
      <div>Test_page2</div>
    </>
  )
}
